// Run a callback once the browser is idle (or after `timeout` ms at the latest).
// Keeps non-critical work off the path to first paint. Client-only. Returns a cancel function.
export function runWhenIdle(callback: () => void, timeout = 2000): () => void {
  if (typeof window === "undefined") return () => {};
  if (typeof window.requestIdleCallback === "function") {
    const id = window.requestIdleCallback(callback, { timeout });
    return () => window.cancelIdleCallback(id);
  }
  const id = window.setTimeout(callback, 200);
  return () => window.clearTimeout(id);
}
